import { WHATSAPP_NUMBER } from '../data/constants'

export const getWhatsAppUrl = (message: string) => {
  const encodedMessage = encodeURIComponent(message)
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`
}
